import { render } from "./nultiUnitModel.vue?vue&type=template&id=4c2353fc"
import script from "./nultiUnitModel.vue?vue&type=script&lang=js"
export * from "./nultiUnitModel.vue?vue&type=script&lang=js"

import "./nultiUnitModel.vue?vue&type=style&index=0&id=4c2353fc&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__